import React, { useState, useRef, useEffect } from "react";
import {
  Button,
  Divider,
  Form,
  Radio,
  Select,
  Input,
  Pagination,
  Empty,
  Upload,
} from "antd";

import { useNavigate } from "react-router-dom";
import "./evaluationsQuestionsCardList.scss";
import useRDBStore from "../../store/rdb";
import EvaluationQuestionsCard from "../evaluationQuestionsCard";
import TextArea from "antd/es/input/TextArea";
import useJDStore from "../../store/jd.store";
import { UploadOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import useQCEStore from "../../store/qce.store";
import useGlobalQCEStore from "../../store/globalqce.store";

export default function EvaluationQuestionsCardList({
  qhjid,
  ev_id,
  evalDesc,
  localQDesc,
  setView,
  localQHanlder,
  localQDeleteHandler,
  localQCopyHandler,
  localFilteredList,
  localFilteredQHanlder,
  localFilterView,
  localQDescDeletedList,
  globalEvaluationPage,
}) {
  var userData = JSON.parse(localStorage.getItem("userDetails"));
  const [localCurrentView, setLocalCurrentView] = useState("qset");
  const [data, setData] = useState([]);
  const { selectedJD } = useJDStore();
  const { AddQuestionsToEval, updateEvalState, LinkQuestionsToEval } =
    useQCEStore();
  const { updateGlobalEvalState } = useGlobalQCEStore();
  const [questionType, setQuestionType] = useState("Multiple Choice");
  const [selectedSkill, setSelectedSkill] = useState(
    evalDesc.skillarray[0].skill.toUpperCase(),
  );
  const [selectedLevel, setSelectedLevel] = useState(
    evalDesc.skillarray[0].level,
  );
  const [selectedAssessmentType, setSelectedAssessmentType] = useState(
    evalDesc.skillarray[0].assessmenttype,
  );
  const [selectedWeightage, setSelectedWeightage] = useState(
    evalDesc.skillarray[0].weightage ? "Mandatory" : "Optional",
  );
  const [editIndex, setEditIndex] = useState(-1);
  const [editItem, setEditItem] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [enableButtons, setEnableButtons] = useState(0);
  const [deLinkQForQSET, setDeLinkQForQSET] = useState([]);

  const itemsPerPage = 10;

  const activeList =
    localFilterView == "normal" ? localQDesc || [] : localFilteredList || [];

  const totalItems = activeList.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedQuestions = activeList.slice(
    startIndex,
    startIndex + itemsPerPage,
  );

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, totalPages]);

  useEffect(() => {
    setCurrentPage(1);
  }, [localFilterView, totalItems]);

  const handlePageChange = (page) => {
    if (page !== currentPage) {
      setCurrentPage(page);
      console.log("Showing the current page", page);
    }
    //rdbResumeSearchPerPage();
  };

  const customRequest = ({ file, onSuccess }) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const binaryStr = event.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);
      setData([...jsonData]);

      for (let idx = 0; idx < jsonData?.length; idx++) {
        handleFormSubmitXlsSheet(jsonData[idx]);
      }

      onSuccess("ok");
      console.log("uploaded data", jsonData);
    };
    reader.readAsArrayBuffer(file);
  };
  const convertJson = () => {
    let encodedJsonValues = {};
    encodedJsonValues.questionsinfoarray = [];
    let qinfo = {};

    //first find the add or update
    for (let idx = 0; idx < localQDesc?.length; idx++) {
      if (
        localQDesc[idx].action == "ADD" ||
        localQDesc[idx].action == "UPDATE"
      ) {
        qinfo = {};
        qinfo.action = localQDesc[idx].action;
        qinfo.qdesc = {};
        qinfo.qdesc.qhoid = userData.qhoid;
        qinfo.qdesc.questionid = localQDesc[idx].ID || localQDesc[idx]?.id;
        qinfo.qdesc.source = localQDesc[idx].source;
        qinfo.qdesc.questiontype = localQDesc[idx].questiontype;
        qinfo.qdesc.question = localQDesc[idx].question;
        qinfo.qdesc.multiplechoicecode = localQDesc[idx].multiplechoicecode;
        qinfo.qdesc.optiona = localQDesc[idx].optiona;
        qinfo.qdesc.optionb = localQDesc[idx].optionb;
        qinfo.qdesc.optionc = localQDesc[idx].optionc;
        qinfo.qdesc.optiond = localQDesc[idx].optiond;
        qinfo.qdesc.answer = localQDesc[idx].answer;
        qinfo.qdesc.explanation = localQDesc[idx].explanation;
        qinfo.qdesc.output = localQDesc[idx].output;
        qinfo.qdesc.level = localQDesc[idx].level;
        qinfo.qdesc.category = localQDesc[idx].category;
        qinfo.qdesc.skill = localQDesc[idx].skill;
        qinfo.qdesc.weightage = localQDesc[idx].weightage;
        qinfo.qdesc.assessmenttype = localQDesc[idx].assessmenttype;
        qinfo.qdesc.updatedby = {};
        qinfo.qdesc.updatedby.qhuid = localQDesc[idx].updatedby.qhuid;
        qinfo.qdesc.updatedby.name = localQDesc[idx].updatedby.updatedbyname;
        qinfo.qdesc.updatedby.updatedon = localQDesc[idx].updatedby.updatedon;

        encodedJsonValues.questionsinfoarray.push(qinfo);
      }
    }
    //now find the delete list
    for (let idx = 0; idx < localQDescDeletedList?.length; idx++) {
      qinfo = {};
      qinfo.action = "DELETE";
      qinfo.qdesc = {};
      qinfo.qdesc.qhoid = userData.qhoid;
      qinfo.qdesc.questionid =
        localQDescDeletedList[idx].questionid ||
        localQDescDeletedList[idx].ID ||
        localQDescDeletedList[idx].id;
      qinfo.qdesc.source = localQDescDeletedList[idx].source;
      encodedJsonValues.questionsinfoarray.push(qinfo);
    }
    return encodedJsonValues;
  };
  const handleSaveAndUpdate = (value) => {
    const jasonValues = convertJson();
    AddQuestionsToEval({
      jasonValues,
      qhjid,
      ev_id,
    });
    setView("all");
  };
  const enCodeJsonDeLink = () => {
    let encodedJsonValues = {};

    encodedJsonValues.action = "DELETE";
    encodedJsonValues.questionidarr = [];
    encodedJsonValues.evid = ev_id;
    //first find the add or update
    for (let idx = 0; idx < deLinkQForQSET?.length; idx++) {
      encodedJsonValues.questionidarr.push(deLinkQForQSET[idx].ID);
    }
    let newDate = getTimeNow();
    encodedJsonValues.updatedby = {};
    encodedJsonValues.updatedby.qhuid = userData.qhuid;
    encodedJsonValues.updatedby.updatedbyname = userData.username;
    encodedJsonValues.updatedby.updatedon = newDate;

    return encodedJsonValues;
  };

  const handleDelinkFromQset = (value) => {
    const jasonValues = enCodeJsonDeLink();
    LinkQuestionsToEval({
      jasonValues,
      qhjid,
      ev_id,
    });
    setDeLinkQForQSET([]);
  };
  const encodeJsonState = (value) => {
    var encodedJsonValues = {};

    encodedJsonValues.evid = ev_id;
    encodedJsonValues.state = value;

    const date = new Date(); // Or your specific Date object
    const unixTimestampMilliseconds = date.getTime();
    const unixTimestampSeconds = Math.floor(unixTimestampMilliseconds / 1000);

    encodedJsonValues.activationtime = unixTimestampSeconds; // To Activate later in time

    let newDate = getTimeNow();
    encodedJsonValues.updatedby = {};
    encodedJsonValues.updatedby.qhuid = userData.qhuid;
    encodedJsonValues.updatedby.updatedbyname = userData.username;
    encodedJsonValues.updatedby.updatedon = newDate;

    return encodedJsonValues;
  };

  const handleStateUpdate = async (value) => {
    var jasonValues = encodeJsonState(value);

    if (globalEvaluationPage) {
      await updateGlobalEvalState({
        body: { state: jasonValues.state },
        ev_id,
      });
    } else {
      await updateEvalState({
        jasonValues,
        qhjid,
        ev_id,
      });
    }
    setView("all");
  };

  const handleUploadExlSheet = (value) => {
    setLocalCurrentView("ExlSheet");
  };

  const handleDelinkQuestions = (value, indexToRemove) => {
    deLinkQForQSET.push(localQDesc[indexToRemove]);
    setDeLinkQForQSET([...deLinkQForQSET]);
    var localQSetNew = localQDesc.filter((_, index) => index !== indexToRemove);
    localQHanlder([...localQSetNew]);
    localFilteredQHanlder([...localQSetNew]);
  };
  const handleEditQuestions = (value, index) => {
    setEditIndex(index);
    setEditItem(true);
    setLocalCurrentView("addnew");
  };
  const handledBackQuestions = (value) => {
    handleAdddNewQuestions(value);
    setEditIndex(-1);
    setEditItem(false);
  };
  const handleAdddNewQuestions = (value) => {
    setLocalCurrentView(value);
  };
  const OnSelectChangeQuestionType = (value) => {
    setQuestionType(value);
  };
  const OnSelectChangeLevel = (value) => {
    setSelectedLevel(value);
  };
  const OnSelectWeightage = (value) => {
    //setSelectedWeightage(value)
  };
  const OnSelectChangeAssessmenttype = (value) => {
    setSelectedAssessmentType(value);
  };
  const OnSelectChangeSkill = (value) => {
    setSelectedSkill(value);
    var s = evalDesc?.skillarray?.filter(
      (item) => item.skill.toLowerCase() == value.toLowerCase(),
    );
    setSelectedWeightage(s?.[0].weightage == 1 ? "Mandatory" : "Optional");
  };

  const getSkillList = evalDesc.skillarray.map((skillItem, idx) => {
    return {
      value: skillItem.skill.toUpperCase(),
      label: skillItem.skill.toUpperCase(),
    };
  });

  //get the time
  function getTimeNow() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    const currentDate = date + "-" + month + "-" + year;
    return currentDate;
  }
  const encodeJson = (value, update) => {
    const userData = JSON.parse(localStorage.getItem("userDetails"));
    let encodedJsonValues = {};

    console.log("values", value);
    if (update == false) {
      encodedJsonValues.action = "ADD";
    } else {
      encodedJsonValues.action = "UPDATE";
    }

    encodedJsonValues.source = "Custom";
    encodedJsonValues.questiontype = questionType;
    encodedJsonValues.question = value.question;
    if (encodedJsonValues.questiontype == "Multiple Choice") {
      encodedJsonValues.optiona = value.optionA;
      encodedJsonValues.optionb = value.optionB;
      encodedJsonValues.optionc = value.optionC;
      encodedJsonValues.optiond = value.optionD;
      encodedJsonValues.answer = value.answer;
      encodedJsonValues.explanation = value.explanation;
    } else if (encodedJsonValues.questiontype == "Multiple Choice Code") {
      encodedJsonValues.multiplechoicecode = value.multiplechoicecode;
      encodedJsonValues.optiona = value.optionA;
      encodedJsonValues.optionb = value.optionB;
      encodedJsonValues.optionc = value.optionC;
      encodedJsonValues.optiond = value.optionD;
      encodedJsonValues.answer = value.answer;
      encodedJsonValues.explanation = value.explanation;
    } else if (encodedJsonValues.questiontype == "Text Input") {
      encodedJsonValues.answer = value.answer;
    } else if (encodedJsonValues.questiontype == "Coding") {
      encodedJsonValues.output = value.output;
    } else if (encodedJsonValues.questiontype == "True/False") {
      encodedJsonValues.answer = value.answer;
    }

    encodedJsonValues.level = selectedLevel;
    encodedJsonValues.category = selectedJD?.JDDetails.JobCategory;
    encodedJsonValues.skill = selectedSkill;
    encodedJsonValues.weightage = selectedWeightage;
    encodedJsonValues.assessmenttype = selectedAssessmentType;

    //encodedJsonValues.comments= value.output

    //get the current date
    let newDate = getTimeNow();
    encodedJsonValues.updatedby = {};
    encodedJsonValues.updatedby.qhuid = userData.qhuid;
    encodedJsonValues.updatedby.updatedbyname = userData.username;
    encodedJsonValues.updatedby.updatedon = newDate;

    return encodedJsonValues;
  };

  const handleFormSubmit = (value) => {
    //console.log("Updated list",localQDesc)
    if (editItem) {
      //update the view
      if (
        localQDesc[editIndex].ID == null &&
        localQDesc[editIndex].id == null &&
        localQDesc[editIndex].questionid == null
      ) {
        var jasonValues = encodeJson(value, false);
      } else {
        var jasonValues = encodeJson(value, editItem);
        console.log("Updating Question Encoded data", jasonValues);
        jasonValues.questionid =
          localQDesc[editIndex].questionid ||
          localQDesc[editIndex].ID ||
          localQDesc[editIndex].id;
      }
      localQDesc[editIndex] = jasonValues;
      console.log("Updated list", localQDesc);
      localQHanlder([...localQDesc]);
    } else {
      var jasonValues = encodeJson(value, false);
      console.log("New Question Encoded data", jasonValues);
      localQDesc?.push(jasonValues);
      localQHanlder([...localQDesc]);
    }
    handleAdddNewQuestions("qset");
  };
  const getUpdatedQuestions = () => {
    var toBeAdded = localQDesc?.filter((item) => item.action == "ADD");
    var toBeupdated = localQDesc?.filter((item) => item.action == "UPDATE");

    return toBeAdded.length + toBeupdated.length;
  };
  const encodeJsonXLS = (value, update) => {
    const userData = JSON.parse(localStorage.getItem("userDetails"));
    let encodedJsonValues = {};

    //console.log("values",value)
    if (update == false) {
      encodedJsonValues.action = "ADD";
    } else {
      encodedJsonValues.action = "UPDATE";
    }
    encodedJsonValues.source = "Custom";
    encodedJsonValues.questiontype = value.questionType;
    encodedJsonValues.question = value.question;
    if (encodedJsonValues.questiontype == "Multiple Choice") {
      encodedJsonValues.optiona = value.optionA.toString();
      encodedJsonValues.optionb = value.optionB.toString();
      encodedJsonValues.optionc = value.optionC.toString();
      encodedJsonValues.optiond = value.optionD.toString();
      encodedJsonValues.answer = value.answer;
      encodedJsonValues.explanation = value.explanation;
    } else if (encodedJsonValues.questiontype == "Multiple Choice Code") {
      encodedJsonValues.multiplechoicecode = value.multiplechoicecode;
      encodedJsonValues.optiona = value.optionA.toString();
      encodedJsonValues.optionb = value.optionB.toString();
      encodedJsonValues.optionc = value.optionC.toString();
      encodedJsonValues.optiond = value.optionD.toString();
      encodedJsonValues.answer = value.answer;
      encodedJsonValues.explanation = value.explanation;
    } else if (encodedJsonValues.questiontype == "Text Input") {
      encodedJsonValues.answer = value.answer.toString();
    } else if (encodedJsonValues.questiontype == "Coding") {
      encodedJsonValues.output = value.output.toString();
    } else if (encodedJsonValues.questiontype == "True/False") {
      encodedJsonValues.answer = value.answer.toString();
    }

    encodedJsonValues.level = value.level;
    encodedJsonValues.category = value.category;
    encodedJsonValues.skill = value.skill;
    encodedJsonValues.weightage = value.weightage;
    encodedJsonValues.assessmenttype = value.assessmenttype;
    //encodedJsonValues.comments= value.output

    //get the current date
    let newDate = getTimeNow();
    encodedJsonValues.updatedby = {};
    encodedJsonValues.updatedby.qhuid = userData.qhuid;
    encodedJsonValues.updatedby.updatedbyname = userData.username;
    encodedJsonValues.updatedby.updatedon = newDate;

    return encodedJsonValues;
  };
  const handleFormSubmitXlsSheet = (value) => {
    var jasonValues = encodeJsonXLS(value, false);
    //console.log("Question Encoded data", jasonValues)
    //console.log("localQDesc", localQDesc)
    //Add to List.
    localQDesc?.push(jasonValues);
    //console.log("Updated list",localQDesc)

    //update the view
    localQHanlder([...localQDesc]);
    localFilteredQHanlder([...localQDesc]);
    handleAdddNewQuestions("qset");
  };
  return (
    <div className="evaluationsQuestionsCardList-wrapper">
      <div className="resumeResultsCardList-Top">
        {localCurrentView == "qset" ? (
          <>
            <div className="resumeResultsCardList-buttons">
              {enableButtons ? (
                <>
                  <Button onClick={() => handleAdddNewQuestions("addnew")}>
                    Add New Question
                  </Button>
                  <div className="resumeResultsCardList-buttons">
                    <Upload
                      customRequest={customRequest}
                      showUploadList={true}
                      accept=".xlsx,.xls"
                    >
                      <Button icon={<UploadOutlined />}>
                        Upload Excel File
                      </Button>
                    </Upload>
                  </div>
                  <div className="resumeResultsCardList-buttons">
                    <Button onClick={() => handleSaveAndUpdate()}>
                      Save and Update {"(" + getUpdatedQuestions() + ")"}
                      {"(" + localQDescDeletedList?.length + ")"}
                    </Button>
                  </div>
                </>
              ) : (
                <></>
              )}
              <div className="resumeResultsCardList-buttons">
                <Button onClick={() => handleDelinkFromQset()}>
                  Remove Questions {"(" + deLinkQForQSET?.length + ")"}
                </Button>
              </div>
              <div className="resumeResultsCardList-buttons">
                {evalDesc.state == "Offline" ? (
                  <>
                    <Button onClick={() => handleStateUpdate("Live")}>
                      Go Live !!
                    </Button>
                  </>
                ) : (
                  <>
                    <Button onClick={() => handleStateUpdate("Offline")}>
                      Go Offline
                    </Button>
                  </>
                )}
              </div>
            </div>
          </>
        ) : localCurrentView == "addnew" ? (
          <>
            <div className="resumeResultsCardList-buttons">
              <Button onClick={() => handledBackQuestions("qset")}>Back</Button>
            </div>

            <div className="resumeResultsCardList-buttons">
              Create New Question
            </div>
          </>
        ) : (
          <>
            <div className="resumeResultsCardList-buttons">
              <Button onClick={() => handleAdddNewQuestions("qset")}>
                Back
              </Button>
            </div>

            <div className="resumeResultsCardList-buttons">
              Upload Excel Sheet
            </div>
          </>
        )}
      </div>

      <div style={{ margin: "10px", padding: "10px" }}>
        {localCurrentView == "qset" ? (
          <>
            {localFilterView == "normal" ? (
              <></>
            ) : (
              "Filter Enabled (" + localFilteredList?.length + ") Results Found"
            )}

            {localFilterView == "normal"
              ? paginatedQuestions?.map((qdesc, idx) => (
                  <EvaluationQuestionsCard
                    index={startIndex + idx}
                    evalDesc={evalDesc}
                    localQDesc={localQDesc}
                    localQDeleteHandler={localQDeleteHandler}
                    localQCopyHandler={localQCopyHandler}
                    localQEditHandler={handleEditQuestions}
                    localDelinkHandler={handleDelinkQuestions}
                  />
                ))
              : paginatedQuestions?.map((qdesc, idx) => (
                  <EvaluationQuestionsCard
                    index={startIndex + idx}
                    evalDesc={evalDesc}
                    localQDesc={localFilteredList}
                    localQDeleteHandler={localQDeleteHandler}
                    localQCopyHandler={localQCopyHandler}
                  />
                ))}

            {localQDesc?.length == 0 ? (
              <>
                <Empty style={{ margin: "60px" }}>Please Add Questions</Empty>
              </>
            ) : (
              <></>
            )}
            <div className="resumeDBSearchResults-Pagination-list">
              <Pagination
                total={totalItems}
                showTotal={(total, range) =>
                  `${range[0]}-${range[1]} of ${total} items`
                }
                pageSize={itemsPerPage}
                current={currentPage}
                onChange={handlePageChange}
                align="center"
                showSizeChanger={false}
              />
            </div>
          </>
        ) : localCurrentView == "addnew" ? (
          <>
            <Form
              name="Questions-form"
              justify="start"
              layout="vertical"
              autoComplete="off"
              onFinish={handleFormSubmit}
              initialValues={{
                skill: editItem ? localQDesc[editIndex].skill : selectedSkill,
                assessmenttype: editItem
                  ? localQDesc[editIndex]?.assessmenttype
                  : selectedAssessmentType,
                level: editItem ? localQDesc[editIndex]?.level : selectedLevel,
                questiontype: editItem
                  ? localQDesc[editIndex]?.questiontype
                  : "Multiple Choice",
                question: editItem ? localQDesc[editIndex]?.question : "",
                multiplechoicecode: editItem
                  ? localQDesc[editIndex]?.multiplechoicecode
                  : "",
                optionA: editItem ? localQDesc[editIndex]?.optiona : "",
                optionB: editItem ? localQDesc[editIndex]?.optionb : "",
                optionC: editItem ? localQDesc[editIndex]?.optionc : "",
                optionD: editItem ? localQDesc[editIndex]?.optiond : "",
                answer: editItem ? localQDesc[editIndex]?.answer : "",
                output: editItem ? localQDesc[editIndex]?.output : "",
              }}
            >
              <div className="question-dual-input-wrapper">
                <Form.Item name="skill" required={true} label="Skill">
                  <Select
                    required={true}
                    name="skill"
                    className="e-members-input"
                    onChange={OnSelectChangeSkill}
                    options={getSkillList}
                  />
                </Form.Item>
                <Form.Item
                  name="assessmenttype"
                  required={true}
                  label="Assessment Type"
                >
                  <Select
                    required={true}
                    name="assessmenttype"
                    className="e-members-input"
                    onChange={OnSelectChangeAssessmenttype}
                    options={[
                      { value: "Programming", label: "Programming" },
                      { value: "Domain", label: "Domain" },
                      { value: "Framework", label: "Framework" },
                      { value: "Role", label: "Role" },
                      { value: "Exp", label: "Exp" },
                    ]}
                  />
                </Form.Item>
              </div>
              <div className="question-dual-input-wrapper">
                <Form.Item name="weightage" required={true} label="Weightage">
                  <Select
                    required={true}
                    disabled
                    name="weightage"
                    className="e-members-input"
                    defaultValue={selectedWeightage}
                    onChange={OnSelectWeightage}
                    options={[
                      { value: "Mandatory", label: "Mandatory" },
                      { value: "Optional", label: "Optional" },
                    ]}
                  />
                </Form.Item>
                <Form.Item
                  name="level"
                  required={true}
                  label="Difficulty Level"
                >
                  <Select
                    required={true}
                    name="level"
                    className="e-members-input"
                    onChange={OnSelectChangeLevel}
                    options={[
                      { value: "Easy", label: "Easy" },
                      { value: "Intermediate", label: "Intermediate" },
                      { value: "Expert", label: "Expert" },
                    ]}
                  />
                </Form.Item>
              </div>

              <Form.Item
                name="questiontype"
                required={true}
                label="Question Type"
              >
                <Select
                  required={true}
                  name="questiontype"
                  className="e-members-input"
                  onChange={OnSelectChangeQuestionType}
                  options={[
                    { value: "Multiple Choice", label: "Multiple Choice" },
                    {
                      value: "Multiple Choice Code",
                      label: "Multiple Choice Code",
                    },
                    { value: "Text Input", label: "Text Input" },
                    { value: "Coding", label: "Coding" },
                    { value: "True/False", label: "True/False" },
                    { value: "Exp", label: "Exp" },
                  ]}
                />
              </Form.Item>
              <Form.Item required={true} name="question" label="Question">
                <TextArea required={true} className="questions-title-input" />
              </Form.Item>
              {questionType == "Multiple Choice Code" ? (
                <>
                  <Form.Item
                    required={true}
                    name="multiplechoicecode"
                    label="Code"
                  >
                    <TextArea
                      required={true}
                      className="questions-title-input"
                    />
                  </Form.Item>
                  <Form.Item required={true} name="optionA" label="Option A">
                    <Input required={true} className="questions-input" />
                  </Form.Item>
                  <Form.Item required={true} name="optionB" label="Option B">
                    <Input required={true} className="questions-input" />
                  </Form.Item>
                  <Form.Item required={true} name="optionC" label="Option C">
                    <Input required={true} className="questions-input" />
                  </Form.Item>
                  <Form.Item required={true} name="optionD" label="Option D">
                    <Input required={true} className="questions-input" />
                  </Form.Item>
                  <Form.Item required={true} name="answer" label="Answer">
                    <Input required={true} className="questions-input" />
                  </Form.Item>
                  <Form.Item name="explanation" label="Explanation">
                    <Input
                      defaultValue={
                        editItem ? localQHanlder[editIndex]?.explanation : ""
                      }
                      className="questions-input"
                    />
                  </Form.Item>
                </>
              ) : questionType == "Multiple Choice" ? (
                <>
                  <Form.Item required={true} name="optionA" label="Option A">
                    <Input required={true} className="questions-input" />
                  </Form.Item>
                  <Form.Item required={true} name="optionB" label="Option B">
                    <Input required={true} className="questions-input" />
                  </Form.Item>
                  <Form.Item required={true} name="optionC" label="Option C">
                    <Input required={true} className="questions-input" />
                  </Form.Item>
                  <Form.Item required={true} name="optionD" label="Option D">
                    <Input required={true} className="questions-input" />
                  </Form.Item>
                  <Form.Item required={true} name="answer" label="Answer">
                    <Input required={true} className="questions-input" />
                  </Form.Item>
                  <Form.Item name="explanation" label="Explanation">
                    <Input
                      defaultValue={
                        editItem ? localQHanlder[editIndex]?.explanation : ""
                      }
                      className="questions-input"
                    />
                  </Form.Item>
                </>
              ) : questionType == "Text Input" ? (
                <>
                  <Form.Item required={true} name="answer" label="Answer">
                    <Input required={true} className="questions-input" />
                  </Form.Item>
                </>
              ) : questionType == "Coding" ? (
                <>
                  <Form.Item name="output" label="Output">
                    <Input className="questions-input" />
                  </Form.Item>
                </>
              ) : questionType == "True/False" ? (
                <>
                  <Form.Item required={true} label="Answer" name="answer">
                    <Radio.Group
                      className="profile-radio-wrapper"
                      name="answer"
                    >
                      <Radio className="radio-option" value="True">
                        True
                      </Radio>
                      <Radio className="radio-option" value="False">
                        False
                      </Radio>
                    </Radio.Group>
                  </Form.Item>
                </>
              ) : (
                <></>
              )}

              <Button type="primary" htmlType="submit">
                {editItem ? "Save Changes" : "Add Question"}
              </Button>
            </Form>
          </>
        ) : (
          <>
            <pre>{JSON.stringify(data, null, 2)}</pre>
          </>
        )}
      </div>
    </div>
  );
}
